import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './DeleteTeamModal.css';
import { useI18n } from '../../i18n';

const TrashRedIcon = () => (
    <svg width="25" height="25" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M60.75 13.5H50.625V10.125C50.625 8.03642 49.7953 6.03338 48.3185 4.55653C46.8416 3.07969 44.8386 2.25 42.75 2.25H29.25C27.1614 2.25 25.1584 3.07969 23.6815 4.55653C22.2047 6.03338 21.375 8.03642 21.375 10.125V13.5H11.25C10.3549 13.5 9.49645 13.8556 8.86351 14.4885C8.23058 15.1214 7.875 15.9799 7.875 16.875C7.875 17.7701 8.23058 18.6286 8.86351 19.2615C9.49645 19.8944 10.3549 20.25 11.25 20.25H12.375V58.5C12.375 59.9918 12.9676 61.4226 14.0225 62.4775C15.0774 63.5324 16.5082 64.125 18 64.125H54C55.4918 64.125 56.9226 63.5324 57.9775 62.4775C59.0324 61.4226 59.625 59.9918 59.625 58.5V20.25H60.75C61.6451 20.25 62.5035 19.8944 63.1365 19.2615C63.7694 18.6286 64.125 17.7701 64.125 16.875C64.125 15.9799 63.7694 15.1214 63.1365 14.4885C62.5035 13.8556 61.6451 13.5 60.75 13.5ZM28.125 10.125C28.125 9.82663 28.2435 9.54048 28.4545 9.3295C28.6655 9.11853 28.9516 9 29.25 9H42.75C43.0484 9 43.3345 9.11853 43.5455 9.3295C43.7565 9.54048 43.875 9.82663 43.875 10.125V13.5H28.125V10.125ZM52.875 57.375H19.125V20.25H52.875V57.375ZM32.625 29.25V47.25C32.625 48.1451 32.2694 49.0035 31.6365 49.6365C31.0036 50.2694 30.1451 50.625 29.25 50.625C28.3549 50.625 27.4964 50.2694 26.8635 49.6365C26.2306 49.0035 25.875 48.1451 25.875 47.25V29.25C25.875 28.3549 26.2306 27.4964 26.8635 26.8635C27.4964 26.2306 28.3549 25.875 29.25 25.875C30.1451 25.875 31.0036 26.2306 31.6365 26.8635C32.2694 27.4964 32.625 28.3549 32.625 29.25ZM46.125 29.25V47.25C46.125 48.1451 45.7694 49.0035 45.1365 49.6365C44.5035 50.2694 43.6451 50.625 42.75 50.625C41.8549 50.625 40.9965 50.2694 40.3635 49.6365C39.7306 49.0035 39.375 48.1451 39.375 47.25V29.25C39.375 28.3549 39.7306 27.4964 40.3635 26.8635C40.9965 26.2206 41.8549 25.875 42.75 25.875C43.6451 25.875 44.5035 26.2306 45.1365 26.8635C45.7694 27.4964 46.125 28.3549 46.125 29.25Z" fill="#FF534B" />
    </svg>
);

const DeleteTeamModal = ({ isOpen, onClose, onConfirm, team, loading = false }) => {
    const { t } = useI18n();
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    return (
        <div className="delete-team-modal-overlay" onClick={handleBackdropClick}>
            <div className="delete-team-modal">
                <button
                    className="delete-team-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label={t('common.actions.close')}
                >
                    <FaTimes size={9.33} />
                </button>

                <div className="delete-team-modal-header">
                    <div className="delete-team-modal-header-left">
                        <TrashRedIcon />
                        <h2 className="delete-team-modal-title">
                            {t('pages.teams.delete_team')}
                        </h2>
                    </div>
                </div>

                <p className="delete-team-modal-description">
                    {t('pages.teams.confirm_delete')}
                </p>

                <div className="delete-team-modal-actions">
                    <button
                        className="delete-team-modal-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {t('common.actions.cancel')}
                    </button>
                    <button
                        className="delete-team-modal-delete"
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? t('common.status.deleting') : t('common.actions.delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteTeamModal;
